module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isEditValid),
      callback: function($$v) {
        _vm.isEditValid = $$v
      },
      expression: "isEditValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Privilege Key:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Key",
      "disabled": "",
      "rules": _vm.keyRules,
      "required": "",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.objPrivEdit.priv_key),
      callback: function($$v) {
        _vm.$set(_vm.objPrivEdit, "priv_key", $$v)
      },
      expression: "objPrivEdit.priv_key"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Privilege Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Description",
      "rules": _vm.descriptionRules,
      "required": "",
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.objPrivEdit.description),
      callback: function($$v) {
        _vm.$set(_vm.objPrivEdit, "description", $$v)
      },
      expression: "objPrivEdit.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isEditValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncEditPriv()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}